import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/salesContent';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="px-5 py-14 sm:px-8" style={{
    backgroundColor: '#0d2a1a'
  }} data-id="element-38" data-mp="1lb90yxa19gj2">
      <div className="mx-auto max-w-3xl" data-id="element-39" data-mp="1gcxqckbwz1zs">
        <h2 className="text-center font-display text-[23px] font-bold text-gold sm:text-[28px]" data-id="element-40" data-mp="1ge0eikhuqqc0">
          Respuestas Rápidas
        </h2>

        <div className="mt-8 divide-y divide-white/10 border-y border-white/10" data-id="element-41" data-mp="2dy3gdfrztppo">
          {faqs.map((item, index) => <FaqRow key={item.question} question={item.question} answer={item.answer} isOpen={open === index} onToggle={() => setOpen(open === index ? null : index)} data-id="element-42" data-mp="242a13omw3i47" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}
interface FaqRowProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FaqRow({
  question,
  answer,
  isOpen,
  onToggle
}: FaqRowProps) {
  return <div data-id="element-43" data-mp="phxyzdd79pqq">
      <h3 data-id="element-44" data-mp="phej02741bfc">
        <button type="button" onClick={onToggle} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-4 text-left text-[14px] font-bold text-white transition-colors duration-200 ease-out hover:text-gold sm:text-[15px]" data-id="element-45" data-mp="pho9dqw2hklk">
          {question}
          <ChevronDownIcon aria-hidden="true" className={`h-4 w-4 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} data-id="element-46" data-mp="kiuubu14tlja" />
        </button>
      </h3>
      <div className="overflow-hidden transition-[max-height,opacity] duration-300 ease-out" style={{
      maxHeight: isOpen ? '260px' : '0px',
      opacity: isOpen ? 1 : 0
    }} data-id="element-47" data-mp="6plou4gb1k61">
        <p className="pb-4 pr-8 text-[14px] leading-relaxed text-white/65" data-id="element-48" data-mp="3swjyr3neuroz">{answer}</p>
      </div>
    </div>;
}